import React, { useEffect, useState } from 'react';
import { TableWrapper, Table, PaginationTable } from 'components/Global';
import { ReactComponent as ZoneFilledIcon } from 'icons/zone-filled-icon.svg';
import { useDispatch, useSelector } from 'react-redux';
import { deleteZoneTypeById, getAllZoneType } from 'features/zone/actions';
import { useAppContext } from 'components/Context/AppContext';
import { checkPermission } from 'utils/functionality';
import { trackEvent } from 'utils/analytics';
import AddZoneTypeModal from 'components/Modals/AddZoneTypeModal';
import ReactDOM from 'react-dom';

const ZoneTypeTab = ({ showModal, setShowModal }) => {
  const { showToast, setShowConfirmation, setShowSpinner } = useAppContext();
  const dispatch = useDispatch();
  const [currentPage, setCurrentPage] = useState(1);
  const { isLoading, data: zoneTypes } = useSelector((state) => state.zoneType);
  const { offCanvasMenu, currentMenu } = useSelector((state) => state.menu);

  const column = [
    { header: 'No.', value: 'no' },
    { header: 'Nama Tipe Daerah', value: 'name' },
  ];

  useEffect(() => {
    dispatch(getAllZoneType({ page: currentPage }));
  }, [currentPage]);

  const handleDelete = (e) => {
    const zoneId = e.target.parentElement.parentElement.dataset['key'];

    setShowConfirmation({
      message: 'Apakah anda yakin ingin menghapus Mobil',
      show: true,
      onClick: async () => {
        try {
          trackEvent('zone_type_deleted', { zone_type_id: zoneId, source: 'zone_type_list' });
          await dispatch(deleteZoneTypeById(zoneId)).unwrap();
          showToast({ type: 'success', message: 'Berhasil Menghapus Data Tipe Daerah Zona' });
          setCurrentPage(1);
          dispatch(getAllZoneType({ page: 1 }));
        } catch {
          showToast({ type: 'error', message: 'Gagal Menghapus Data Tipe Daerah Zona!' });
        }
      },
    });
  };

  const handleEdit = (e) => {
    const id = e.target.parentElement.parentElement.dataset['key'];

    setShowModal({ show: true, id: id });
  };

  useEffect(() => {
    if (isLoading) {
      setShowSpinner(true);
    } else {
      setShowSpinner(false);
    }
  }, [isLoading]);

  return (
    <div className="zone">
      <TableWrapper icon={<ZoneFilledIcon fill="#009EF7" width="25px" height="25px" />} title="Zona">
        <Table
          column={column}
          actionBtn
          onDel={handleDelete}
          onEdit={checkPermission(offCanvasMenu, currentMenu, 'update') ? handleEdit : false}
          data={zoneTypes?.data}
          currentPage={currentPage}
        />
        <PaginationTable
          currentPage={currentPage}
          onPageChange={(newPage) => setCurrentPage(newPage)}
          totalCount={zoneTypes?.pagination?.total_data}
        />
      </TableWrapper>
      {showModal.show &&
        ReactDOM.createPortal(
          <AddZoneTypeModal showModal={showModal} setShowModal={setShowModal} />,
          document.getElementById('modal'),
        )}
    </div>
  );
};

export default ZoneTypeTab;
